import Reveal from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";

const FLAVOURS = [
  { name: "Signature Soft Vanilla", desc: "Our legendary soft vanilla — impossibly smooth, churned to silk since 1907.", img: "/flavour-vanilla.webp", tag: "The Signature" },
  { name: "Chocolate", desc: "Deep, dark and double-churned — a parlour classic that never leaves the display.", img: "/flavour-chocolate.webp", tag: "The Classic" },
  { name: "San Teodoro Pistachio", desc: "Golden Sardinian pistachios, roasted and folded through sweet cream.", img: "/flavour-pistachio.webp", tag: "Sardinian Gold" },
  { name: "Piemonte Hazelnut", desc: "Nutty, toasted and luxuriously rich — straight from the hills of Piedmont.", img: "/flavour-hazelnut.webp", tag: "Italian Roast" },
  { name: "Strawberry", desc: "Ripe summer strawberries rippled through fresh dairy cream.", img: "/flavour-strawberry.webp", tag: "Crowd Favourite" },
  { name: "Dulce de Leche", desc: "Slow-caramelised milk, golden and velvet-soft in every spoonful.", img: "/flavour-dulce.webp", tag: "Caramel Silk" },
  { name: "Mint", desc: "Cool, bright and refreshing — the perfect palate-cleanser by the sea.", img: "/flavour-mint.webp", tag: "Cool & Fresh" },
  { name: "Venezuelan Chocolate Sorbet", desc: "Intense single-origin cacao, dairy-free and decadently dark.", img: "/flavour-choc-sorbet.webp", tag: "Vegan Sorbet" },
  { name: "Sorrento Lemon Sorbet", desc: "Zested Amalfi-coast lemons — sunshine sharp, dairy-free and dazzling.", img: "/flavour-lemon.webp", tag: "Vegan Sorbet" },
];

const Flavours = () => (
  <section id="flavours" data-testid="flavours-section" className="py-28 md:py-36 bg-white/60 relative overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
        <SectionHeading overline="Signature Ice Cream" title="Our Famous Flavours" />
        <Reveal delay={0.15}>
          <p className="max-w-xs text-sm text-teal/60 leading-relaxed md:text-right">
            Churned fresh every morning in the parlour — including dairy-free vegan
            sorbets, so everyone gets a scoop.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
        {FLAVOURS.map((f, i) => (
          <Reveal key={f.name} delay={(i % 3) * 0.08} className={i % 3 === 1 ? "lg:mt-14" : ""}>
            <article data-testid={`flavour-card-${i}`} className="group text-center cursor-default">
              <div className="relative mx-auto w-40 h-40 md:w-44 md:h-44">
                <div className="absolute -inset-2 rounded-full border border-gold/50 scale-95 group-hover:scale-105 transition-transform duration-500" aria-hidden="true" />
                <div className="w-full h-full rounded-full overflow-hidden shadow-lg shadow-teal/15">
                  <img src={f.img} alt={`${f.name} at Morelli's`} loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                </div>
                <span className={`absolute -bottom-2 left-1/2 -translate-x-1/2 text-[10px] uppercase tracking-[0.15em] px-3 py-1 rounded-full whitespace-nowrap transition-colors duration-300 ${f.tag.includes("Vegan") ? "bg-gold text-teal-deep group-hover:bg-teal group-hover:text-cream" : "bg-teal text-cream group-hover:bg-gold group-hover:text-teal-deep"}`}>
                  {f.tag}
                </span>
              </div>
              <h3 className="font-display font-bold text-xl mt-7 text-teal group-hover:text-gold transition-colors duration-300">{f.name}</h3>
              <p className="text-sm text-teal/65 mt-2 leading-relaxed max-w-[15rem] mx-auto">{f.desc}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Flavours;
